//
//
//
//

import Regist from '@/components/regist'
export default {
  name: 'regist',
  props: [],
  components: {
    Regist
  },
  data () {
    return {
    }
  },
  created () {},
  mounted () {},
  watch: {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/common/regist.vue